import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CvMtaModel } from '@acorn-portal/shared/src/services/api';

const INITIAL_STATE: CvMtaModel = {
	invalidMtaStartDate: false,
	transactionId: '',
	vehicleDetails: {
		businessRadius: '',
		hasInternalRacking: false,
		vehicleCarriesDangerousGoods: false,
		vehicleVisitsHazardousSites: false,
		abiCode: '',
		abiGroup: 0,
		annualMileage: 0,
		businessMileage: 0,
		bodyType: '',
		registration: '',
		make: '',
		model: '',
		numberOfDoors: '',
		fuelType: '',
		transmission: '',
		grossWeight: undefined,
		engineSize: 0,
		value: 0,
		yearOfManufacture: 0,
		isLeftHandDrive: false,
		datePurchased: '',
		isQPlate: false,
		isImported: false,
		vehicleUse: '',
		ownership: '',
		registeredKeeper: '',
		registrationDate: '',
		countryOfRegistration: '',
		numberOfSeats: '',
		vehicleOvernight: '',
		overnightAddress: undefined,
		modifications: [],
		securityDevices: undefined,
		coverDefinitionCode: undefined,
		telematicsBox: undefined,
		licencingAuthority: '',
	},
	policyDetails: {
		policyholder: {
			isHomeOwner: false,
			address: {
				postcode: '',
				line1: '',
				city: '',
			},
		},
		operatingArea: '',
	},
	drivers: [],
};

export const midTermAdjustmentAPISlice = createSlice({
	name: 'midTermAdjustment',
	initialState: INITIAL_STATE,
	reducers: {
		updateApiMTA: (state, action: PayloadAction<Partial<CvMtaModel>>) => {
			const newState: CvMtaModel = {
				...state,
				...action.payload,
				vehicleDetails: {
					...state.vehicleDetails,
					...action.payload.vehicleDetails,
					overnightAddress: action.payload.vehicleDetails?.overnightAddress || {
						line1: '',
						city: '',
						postcode: '',
					},
				},
			};
			return newState;
		},
		resetApiMTA: () => INITIAL_STATE,
	},
});

export const { updateApiMTA, resetApiMTA } = midTermAdjustmentAPISlice.actions;

export default midTermAdjustmentAPISlice.reducer;
